import React, {FC} from "react";
import {
    Box,
    Button,
} from "@mui/material";
import {AutocompleteGeneric} from "../../table/AutocompleteGeneric";
import {Locale} from "../../../locales/Locale";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {useTranslation} from "react-i18next";

interface Props {
    typeFilter: string | number | null;
    cityFilter: string | number | null;
    setTypeFilter: (val: string | number | null) => void;
    setCityFilter: (val: string | number | null) => void;
    onFilter: () => void;
    onReset: () => void;
    availableTypeOptions: {id: string; name: string}[];
    availableCityOptions: {id: string; name: string}[];
}

export const GarageTableFiltersDesktop: FC<Props> = ({
    typeFilter,
    cityFilter,
    setTypeFilter,
    setCityFilter,
    onFilter,
    onReset,
    availableTypeOptions,
    availableCityOptions,
}) => {
    const {t} = useTranslation();

    return (
        <Box sx={{display: "flex", gap: 2, p: 2, flexWrap: "wrap"}}>
            <AutocompleteGeneric
                options={availableTypeOptions}
                value={typeFilter || null}
                onChange={(val) => setTypeFilter(val ?? null)}
                getOptionLabel={(id) => {
                    const match = availableTypeOptions.find((opt) => opt.id === id);
                    return match ? t(match.name) : "";
                }}
                label={IdlocaGeneric.filter_by_type}
                sx={{minWidth: 220}}
            />
            <AutocompleteGeneric
                options={availableCityOptions}
                value={cityFilter || null}
                onChange={(val) => setCityFilter(val ?? null)}
                getOptionLabel={(id) => {
                    const match = availableCityOptions.find((opt) => opt.id === id);
                    return match ? t(match.name) : "";
                }}
                label={IdlocaGeneric.filter_by_city}
                sx={{minWidth: 220}}
            />
            <Button variant="outlined" onClick={onReset}>
                <Locale localeId={IdlocaGeneric.reset}/>
            </Button>
            <Button variant="contained" onClick={onFilter}>
                <Locale localeId={IdlocaGeneric.filter}/>
            </Button>
        </Box>
    );
};
